// Mock data for Hernandez Remodeling LLC website

export const services = [
  {
    id: 1,
    title: "Kitchen Remodeling",
    description: "Transform your kitchen into a beautiful and functional space with custom cabinets, countertops, and modern appliances.",
    icon: "ChefHat"
  },
  {
    id: 2,
    title: "Bathroom Renovation",
    description: "Create your dream bathroom with expert tile work, modern fixtures, and elegant finishes.",
    icon: "Bath"
  },
  {
    id: 3,
    title: "Basement Finishing",
    description: "Convert your basement into a livable space perfect for entertainment, home offices, or extra bedrooms.",
    icon: "Home"
  },
  {
    id: 4,
    title: "Flooring Installation",
    description: "Professional installation of hardwood, laminate, tile, and vinyl flooring to enhance your home's beauty.",
    icon: "Layers"
  },
  {
    id: 5,
    title: "Roofing Services",
    description: "Quality roofing installation, repair, and maintenance to protect your home from the elements.",
    icon: "Warehouse"
  },
  {
    id: 6,
    title: "Painting & Finishing",
    description: "Interior and exterior painting services with premium paints and meticulous attention to detail.",
    icon: "Paintbrush"
  },
  {
    id: 7,
    title: "Drywall & Sheetrock",
    description: "Expert drywall installation, repair, and finishing for smooth, flawless walls and ceilings.",
    icon: "Square"
  },
  {
    id: 8,
    title: "Deck Construction",
    description: "Build beautiful outdoor living spaces with custom deck design and construction.",
    icon: "Fence"
  },
  {
    id: 9,
    title: "Home Additions",
    description: "Expand your living space with professionally designed and built home additions.",
    icon: "PlusSquare"
  },
  {
    id: 10,
    title: "Plumbing Services",
    description: "Reliable plumbing installation, repair, and maintenance for all your home's needs.",
    icon: "Droplet"
  },
  {
    id: 11,
    title: "Carpentry",
    description: "Custom carpentry work including trim, molding, built-ins, and custom woodwork.",
    icon: "Hammer"
  },
  {
    id: 12,
    title: "General Contracting",
    description: "Full-service contracting for any home improvement project, large or small.",
    icon: "Wrench"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Charlottesville, VA",
    rating: 5,
    text: "Hernandez Remodeling transformed our outdated kitchen into a modern masterpiece. The team was professional, punctual, and the quality of work exceeded our expectations. Highly recommend!",
    project: "Kitchen Remodeling"
  },
  {
    id: 2,
    name: "Michael Davis",
    location: "Louisa, VA",
    rating: 5,
    text: "We hired Hernandez Remodeling for a complete bathroom renovation. They completed the project on time and within budget. The attention to detail was impressive. Will definitely use them again!",
    project: "Bathroom Renovation"
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    location: "Orange, VA",
    rating: 5,
    text: "Our basement was transformed into a beautiful family room. The crew was respectful, clean, and very skilled. The entire process was smooth from start to finish.",
    project: "Basement Finishing"
  },
  {
    id: 4,
    name: "Robert Thompson",
    location: "Gordonsville, VA",
    rating: 5,
    text: "Had a new deck built by Hernandez Remodeling. The craftsmanship is outstanding and the price was very fair. They treated our home like it was their own. Excellent service!",
    project: "Deck Construction"
  },
  {
    id: 5,
    name: "Lisa Anderson",
    location: "Charlottesville, VA",
    rating: 5,
    text: "Professional, reliable, and honest. Hernandez Remodeling painted our entire house interior and the results are beautiful. They respected our home and cleaned up perfectly every day.",
    project: "Painting Services"
  },
  {
    id: 6,
    name: "David Wilson",
    location: "Louisa, VA",
    rating: 5,
    text: "From the initial consultation to project completion, everything was handled professionally. Our new hardwood floors look amazing. Great communication throughout the entire process!",
    project: "Flooring Installation"
  }
];

export const galleryImages = [
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0069.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0071.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0070.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0079.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0078.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0076.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0075.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0073.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0072.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0082.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0080.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0081.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0083.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0085.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0088.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0087.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0086.jpg",
  "https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0084.jpg"
];

export const galleryByCategory = {
  "Kitchen Remodeling": [
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/u3oo53ur_Kitchen.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/s45tfzjl_Kitchen1.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/fkm6cwq5_Kitchen2.JPG"
  ],
  "Bathroom Renovation": [
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/z0koqd91_BR.jpeg",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/h0prepor_BR1.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/r2l3poxj_BR2.JPG"
  ],
  "Flooring Installation": [
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/e01kqfgb_Flooring.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/jfgmm670_Flooring1.JPG"
  ],
  "Painting & Finishing": [
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/x0baxajl_Drywall.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/iprxjobr_Drywall1.JPG",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/4nqfz8jm_Drywall2.jpeg"
  ],
  "General Remodeling": [
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/zs1uq007_Deck1.jpg",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/wmqbyrd1_DeckJob.jpg",
    "https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/kignusr1_House1.jpg"
  ]
};

export const companyInfo = {
  name: "Hernandez Remodeling LLC",
  phone: "(540) 423-5754",
  email: "hernandezremodeling81@gmail.com",
  address: "Gordonsville, Virginia",
  serviceArea: "Serving Gordonsville, Charlottesville, Louisa, Culpeper, Orange, and Surrounding Areas",
  hours: "Monday - Friday: 8:00 AM - 5:00 PM",
  established: "2015"
};

// Mock form submission handler (deprecated - using real backend now)
export const submitQuoteRequest = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};

export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Message sent successfully! We'll get back to you soon." });
    }, 1000);
  });
};
